/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ChatMessageSenderTypes {
  Convive = 'Convive',
  Restaurant = 'Restaurant',
  RelationExperience = 'RelationExperience',
}
